/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompleteOperationNoticeUpload200Response
 */
export interface CompleteOperationNoticeUpload200Response {
    /**
     * 完了した支払業務ID
     * @type {string}
     * @memberof CompleteOperationNoticeUpload200Response
     */
    operationId: string;
}

/**
 * Check if a given object implements the CompleteOperationNoticeUpload200Response interface.
 */
export function instanceOfCompleteOperationNoticeUpload200Response(value: object): value is CompleteOperationNoticeUpload200Response {
    if (!('operationId' in value) || value['operationId'] === undefined) return false;
    return true;
}

export function CompleteOperationNoticeUpload200ResponseFromJSON(json: any): CompleteOperationNoticeUpload200Response {
    return CompleteOperationNoticeUpload200ResponseFromJSONTyped(json, false);
}

export function CompleteOperationNoticeUpload200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompleteOperationNoticeUpload200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'operationId': json['operation_id'],
    };
}

export function CompleteOperationNoticeUpload200ResponseToJSON(json: any): CompleteOperationNoticeUpload200Response {
    return CompleteOperationNoticeUpload200ResponseToJSONTyped(json, false);
}

export function CompleteOperationNoticeUpload200ResponseToJSONTyped(value?: CompleteOperationNoticeUpload200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'operation_id': value['operationId'],
    };
}

